// extracted by mini-css-extract-plugin
module.exports = {"clickable":"OfferCard_clickable__U0rVH","row":"OfferCard_row__mlGz9","checkmark":"OfferCard_checkmark__YV9Se","offer":"OfferCard_offer__LKofY","active":"OfferCard_active__A7mrU"};